import { PdButtonGroup } from "./pd-button-group/PdButtonGroup.js";
//#region src/pd-button-group/pd-button-group.ts
var tag = "pd-button-group";
if (!customElements.get(tag)) customElements.define(tag, PdButtonGroup);
//#endregion
export { PdButtonGroup };
